var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSleepLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.75128,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.497431
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1061 7.18039C5.73489 7.18039 6.24247 6.6965 6.24247 6.09706C6.24247 5.49762 5.73489 5.01373 5.1061 5.01373C4.47731 5.01373 3.96974 5.49762 3.96974 6.09706C3.96974 6.6965 4.47731 7.18039 5.1061 7.18039ZM9.65156 5.01373H6.62125V7.5415H3.59095V4.2915H2.83337V9.70817H3.59095V8.62484H10.4091V9.70817H11.1667V6.45817C11.1667 5.66012 10.4887 5.01373 9.65156 5.01373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1061 7.18039C5.73489 7.18039 6.24247 6.6965 6.24247 6.09706C6.24247 5.49762 5.73489 5.01373 5.1061 5.01373C4.47731 5.01373 3.96974 5.49762 3.96974 6.09706C3.96974 6.6965 4.47731 7.18039 5.1061 7.18039ZM9.65156 5.01373H6.62125V7.5415H3.59095V4.2915H2.83337V9.70817H3.59095V8.62484H10.4091V9.70817H11.1667V6.45817C11.1667 5.66012 10.4887 5.01373 9.65156 5.01373Z",
    fill: "#030972"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepLogo);
export default __webpack_public_path__ + "static/media/sleepLogo.08279951a51a859f619683b23e6d8128.svg";
export { ForwardRef as ReactComponent };